export default __webpack_public_path__ + "static/media/NityaBefore2.76c4b3ef.png";